<template>
  <div class="baniere md:pt-20 pt-6 pb-6 md:pb-24">
    <popupProject
      :want-to-make-offer="activeProjet"
      @oga="retourProjet"
    />
    <div class="w-full p-4 text-center">
      <div class="title w-full md:mt-5">
        Avez-vous un projet en tête ? <span class="col">Allons-y</span>
      </div>
      <div
        class="button mt-6 md:w-1/5 w-4/5 mb-4"
        @click="openProjet"
      >
        Estimer un projet
      </div>
    </div>
  </div>
</template>

<script>
import popupProject from '@/components/popup/popupProject'

export default {
  name: 'Index',
  components: {
    popupProject
  },
  props: {
  },
  data () {
    return {
      activeProjet: false
    }
  },
  created () {
  },
  methods: {
    openProjet () {
      this.activeProjet = true
    },
    retourProjet (answer) {
      this.activeProjet = answer
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto;
   background-color: $background-gray-dev;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }

  .title{
    font-weight: bold;
    font-size: 48px;
    line-height: 170%;
    text-align: center;
    letter-spacing: 0.01em;
    color: $text-black-dev;
    .col{
      color: $text-rose-dev;
    }
  }
  .button{
    background-color: $dev-green;
    height: 60px;
    border-radius: 0px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 29px;
    color: white;

  }

  .baniere:hover{
    background-color: $background-hover;
    .title{
      color: $white;
    }
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .title{
      font-size: 32px;
      line-height: 170%;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .button{
      background-color: $dev-green;
      height: 60px;
      font-size: 20px;
      width: 30%;
    }

  }

</style>
